module.exports = "/_next/static/images/HeroImage-c28d2488b50d1f57d939c2fa41fb8bde.webp";